import { HelpWidgetSession } from '@wix/ambassador-helpwidget-v1-session/types';
import isEmpty from 'lodash/isEmpty';

import { logger } from '../../util/logger';
import { renderModel } from '../../util/renderModel';
import { httpClient } from '../httpClient';
import { ChatbotErrorResponse } from './types';

const {
  clientTopology: { helpWidgetSessionUrl },
} = renderModel.get();

export async function getHelpWidgetSession(): Promise<HelpWidgetSession | null> {
  try {
    const { data } = await httpClient
      .getInstance()
      .get<HelpWidgetSession & ChatbotErrorResponse>(helpWidgetSessionUrl);

    if (isEmpty(data)) {
      return null;
    }

    if (data.error) {
      throw new Error(data.error.message);
    }

    return data;
  } catch (error) {
    const message = 'Failed to get widget session';
    logger.log({ error, message });
    console.error(error);
    return null;
  }
}
